import { useEffect } from 'react';

import InputDate from '../../../components/input-date';

export default function QuestionTypeDatePicker({ question, addError, error, showErrors, getQuestionValue, blockId, sectionId, params, onChange }) {
    const onComponentChange = (e) => {
        const values = getQuestionValue(sectionId, blockId, question.id) || {};

        onChange(e, blockId, question.id);
        setError(e);
    }

    const setError = (values) => {
        if (question.response_required === true) {
            if(question.allow_date_range === true) {
                if (values == null) {
                    addError(true, ['Please select both dates'], sectionId, question.id, question);
                }

                if (Array.isArray(values)) {
                    let checkOne = values[0] == null || values[0].length == 0;
                    let checkTwo = values[1] == null || values[1].length == 0;

                    let check = checkOne || checkTwo;

                    addError(check, ['Please select both dates'], sectionId, question.id, question);
                }
            } else {
                addError(values == null || values.length == 0, ['Please select a date'], sectionId, question.id, question);
            }

            return;
        }
    }

    useEffect(() => {
        setError(getQuestionValue(sectionId, blockId, question.id) || null);
    }, [])

    const newParams = {
        allowDateRange: question.allow_date_range,
    }

    params = Object.assign({}, newParams, params);

    return (
        <div className="section-content__container">
            { params.label && <p className="section-content__label">{ params.label }</p> }
            { params.description && <p className="section-content__description" dangerouslySetInnerHTML={{ __html: params.description }}></p> }

            <InputDate onChange={onComponentChange} { ...params }/>
            { showErrors && error.length > 0 &&
                <div className="section-content__errors">
                    { error.map(err => <p className="section-content__error">{ err }</p>)}
                </div>
            }
        </div>
    )
}
